import type { ComponentProps, ReactNode } from 'react';

export const Circle = 'circle';
export const G = 'g';
export const Line = 'line';
export const Path = 'path';
export const Rect = 'rect';
export const SvgText = 'text';

export function Svg({
  accessibilityLabel,
  width,
  height,
  viewBox,
  children,
}: {
  accessibilityLabel: string;
  accessibilityRole: 'image';
  width: number;
  height: number;
  viewBox: string;
  children: ReactNode;
}) {
  return (
    <svg width={width} height={height} viewBox={viewBox} role="img" aria-label={accessibilityLabel}>
      {children}
    </svg>
  );
}

export function InteractiveCircle({
  accessibilityLabel,
  onPress,
  ...props
}: ComponentProps<'circle'> & { accessibilityLabel: string; onPress: () => void }) {
  return (
    <circle
      {...props}
      aria-label={accessibilityLabel}
      onClick={onPress}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onPress();
        }
      }}
    />
  );
}
